export default function Logo({ className = "h-10", showText = true, darkBg = true }) {
  return (
    <div className="flex items-center" data-testid="brand-logo">
      <img 
        src="/logo-transparent.png" 
        alt="ChannelLoyalty.ai — Amplifying Growth" 
        style={{height: '48px', width: 'auto'}}
      />
    </div>
  );
}
